export default {
    
    name: 'tipos-servicios',
    component: () => import(/* webpackChunkName: "v" */ '@/modules/sgcc/layouts/SgccLayout.vue'),
    children: [
        {
            path: '',
            name: 'typesOfService.home',
            component: () => import(/* webpackChunkName: "typesOfService-home" */ '@/modules/typesOfService/layouts/TypesOfServiceLayout.vue'),
        },
    ],

}